<template>
  <div class="navbar-container dk-navbar">

    <!-- Left: Logo + Menu toggler -->
    <div class="dk-navbar__left">
      <b-link class="dk-navbar__toggler d-xl-none" @click="toggleVerticalMenuActive">
        <feather-icon icon="MenuIcon" size="20" />
      </b-link>
      <router-link to="/" class="dk-navbar__logo">
        <img src="/logo-booster.png" alt="VSLBooster" style="height:36px;width:auto;object-fit:contain;" />
      </router-link>
      <MensagemVerifica v-if="userData && userData.user_ativo === 0" />
    </div>

    <!-- Center: Search bar -->
    <div class="dk-navbar__center">
      <search-bar />
    </div>

    <!-- Right: Actions + User -->
    <div class="dk-navbar__right">
      <dark-toggler class="d-none d-lg-block" />
      <admin-signup-alert />
      <notification-dropdown />
      <upload-videos v-if="$route.path.startsWith('/Videos')" />

      <div class="dk-navbar__divider d-none d-sm-block" />

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <b-avatar
            :src="userData.user_photo_url"
            size="36"
            variant="light-primary"
            badge
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <!-- User info inside dropdown -->
        <div class="dk-dropdown-user-header">
          <b-avatar
            :src="userData.user_photo_url"
            size="42"
            variant="light-primary"
          />
          <div class="dk-dropdown-user-info">
            <strong>{{ userData.user_name }} {{ userData.user_sobrenome }}</strong>
            <span v-if="userData.user_role === 'admin'" class="dk-dropdown-user-role">Admin</span>
            <span v-if="userData.user_email" class="dk-dropdown-user-email">{{ userData.user_email }}</span>
          </div>
        </div>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center">
          <router-link :to="'/perfil'">
            <feather-icon size="16" icon="UserIcon" class="mr-50" />
            <span>Perfil</span>
          </router-link>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center" @click="showScriptModal">
          <feather-icon size="16" icon="CodeIcon" class="mr-50" />
          <span>Script</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </div>

    <!-- Script Modal -->
    <div v-if="scriptModalVisible" class="dk-script-overlay" @click.self="scriptModalVisible = false">
      <div class="dk-script-modal">
        <div class="dk-script-modal__header">
          <div>
            <h5 style="margin:0;color:#fff;font-weight:800;font-size:1rem;">Script de incorporacao</h5>
            <p style="margin:4px 0 0;color:rgba(255,255,255,0.5);font-size:0.8rem;">Cole este script antes do &lt;/body&gt; do seu site. O chat e o player serao carregados automaticamente.</p>
          </div>
          <button class="dk-script-modal__close" @click="scriptModalVisible = false">✕</button>
        </div>
        <div class="dk-script-modal__body">
          <label style="font-size:0.72rem;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:8px;display:block;">Seu script universal</label>
          <div class="dk-script-modal__code-wrap">
            <textarea readonly class="dk-script-modal__textarea" ref="scriptTextarea">{{ scriptEmbed }}</textarea>
            <button class="dk-script-modal__copy" @click="copyScript">
              <feather-icon icon="CopyIcon" size="14" class="mr-50" />
              {{ scriptCopied ? 'Copiado!' : 'Copiar' }}
            </button>
          </div>
          <p style="font-size:0.78rem;color:#64748b;margin-top:12px;line-height:1.5;">
            Este script carrega o <strong>chat</strong> (canto inferior direito) e permite embedar <strong>videos</strong> usando shortcodes como <code style="background:#f1f5f9;padding:2px 6px;border-radius:4px;font-size:0.75rem;">[vid_XXXXX]</code> onde quiser na pagina.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UploadVideos from '@/components/uploadVideos.vue'
import MensagemVerifica from '@/components/MensagemVerifica.vue'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'
import NotificationDropdown from '@/layouts/components/NotificationDropdown.vue'
import AdminSignupAlert from '@/layouts/components/AdminSignupAlert.vue'
import SearchBar from '@core/layouts/components/app-navbar/components/SearchBar.vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    UploadVideos,
    MensagemVerifica,
    NotificationDropdown,
    AdminSignupAlert,
    SearchBar,
    DarkToggler,
  },
  directives: {
    Ripple,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend",
      userData: JSON.parse(localStorage.getItem('userData')) || {},
      plano: '',
      verificaPlano: '',
      authenticated: false,
      rotaAtiva: '',
      scriptModalVisible: false,
      scriptCopied: false,
      mockAccount: {
        password: '',
        userEmail: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      this.rotaAtiva = to.path
    },
  },
  mounted() {
    this.buscarDados()
    setInterval(() => {
      this.LeLocal()
    }, 5000)
    this.$store.commit('User/setUser', JSON.parse(localStorage.getItem('userData')))
  },
  computed: {
    scriptEmbed() {
      const host = (window.location.origin || '').replace(/\/$/, '')
      const uuid = this.userData?.uuid || ''
      return `<script src="${host}/js/booster.min.js" data-booster="${uuid}" async><\/script>`
    },
  },
  methods: {
    showScriptModal() {
      this.scriptCopied = false
      this.scriptModalVisible = true
    },
    copyScript() {
      const text = this.scriptEmbed
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => { this.scriptCopied = true })
      } else {
        const ta = this.$refs.scriptTextarea
        if (ta) { ta.select(); document.execCommand('copy'); this.scriptCopied = true }
      }
      setTimeout(() => { this.scriptCopied = false }, 3000)
    },
    retornarUserAdmin() {
      this.$store.dispatch('User/loginUserClientAdminDKP', {
        ...JSON.parse(localStorage.getItem('lgn_admin_metadata')),
      })
      localStorage.removeItem('lgn_admin_metadata')
      this.$router.replace('/')
    },
    buscarDados() {
      if (!this.userData || !this.userData.id) return
      const options = { method: 'GET' }
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/pagamento/${this.userData.id}`, options)
        .then(response => response.json())
        .then(response => {
          if (response && response.length && response[0]) {
            this.plano = response[0].planocontratado === 'VSL Booster' ? 'CHAT Booster' : 'VSL Booster'
          }
          this.verificaPlano = response ? response.length : 0
        })
        .catch(err => console.error(err))
    },
    LeLocal() {
      this.userData = JSON.parse(localStorage.getItem('userData'))
    },
    setAuthenticated(status) {
      this.authenticated = status
    },
    logout() {
      this.$store.commit('User/setUsuarioDeslogado', false)
      if (this.userData.id === 704641 || this.userData.dono_aluno === 704641) {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        localStorage.removeItem('userData')
        localStorage.removeItem('lgn_admin')
        localStorage.removeItem('lgn_admin_metadata')
        this.$ability.update(initialAbility)
        this.$forceUpdate()
        this.$router.push({ name: 'auth-login-brc' })
      } else {
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        localStorage.removeItem('userData')
        localStorage.removeItem('lgn_admin')
        localStorage.removeItem('lgn_admin_metadata')
        this.$ability.update(initialAbility)
        this.$forceUpdate()
        this.$router.push({ name: 'auth-login' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* Layout removido do scoped — controlado via style.scss global */
</style>

<style>
.dk-script-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(10,15,25,0.7); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center; padding: 20px;
}
.dk-script-modal {
  background: #fff; border-radius: 16px; width: 100%; max-width: 560px;
  box-shadow: 0 24px 64px rgba(0,0,0,0.25); overflow: hidden;
  animation: dk-script-in 0.2s ease;
}
@keyframes dk-script-in {
  from { opacity: 0; transform: translateY(10px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
.dk-script-modal__header {
  background: linear-gradient(135deg, #0D1B2E, #1a3050);
  padding: 24px 28px; display: flex; justify-content: space-between; align-items: flex-start; gap: 16px;
}
.dk-script-modal__close {
  background: none; border: none; color: rgba(255,255,255,0.4); font-size: 20px; cursor: pointer;
  line-height: 1; transition: color 0.2s; flex-shrink: 0;
}
.dk-script-modal__close:hover { color: rgba(255,255,255,0.9); }
.dk-script-modal__body { padding: 24px 28px 28px; }
.dk-script-modal__code-wrap { position: relative; }
.dk-script-modal__textarea {
  width: 100%; min-height: 64px; padding: 14px 16px; padding-right: 100px;
  background: #0D1B2E; color: #F5B935; border: 1px solid #1e3a5f; border-radius: 10px;
  font-family: 'Fira Code', 'Consolas', monospace; font-size: 0.78rem; line-height: 1.5;
  resize: none; outline: none; word-break: break-all;
}
.dk-script-modal__copy {
  position: absolute; top: 10px; right: 10px;
  background: #E86A10; color: #fff; border: none; border-radius: 8px;
  padding: 6px 14px; font-size: 0.75rem; font-weight: 700; cursor: pointer;
  display: flex; align-items: center; transition: all 0.2s;
}
.dk-script-modal__copy:hover { background: #d45e0c; }
</style>
